// db-ui.js

// ─────────────────────────────────────────────────────────────
// Global Login Modal (reusable, lightweight)
// Usage:
//   window.openLoginModal({ type: 'openProductModal', productId: '<gid>' });
//   or add a button: <button data-login-modal data-login-resume='{"type":"openProductModal","productId":"..."}'>Log in</button>
// ─────────────────────────────────────────────────────────────
(function() {
  if (window.__loginModalInit) return; // once
  window.__loginModalInit = true;

  // Create modal once
  const modal = document.createElement('div');
  modal.id = 'gdLoginModal';
  Object.assign(modal.style, {
    position: 'fixed', inset: 0, display: 'none', alignItems: 'center', justifyContent: 'center',
    background: 'rgba(0,0,0,.55)', zIndex: '99999'
  });
  modal.innerHTML = `
    <div style="background:#fff; width:min(420px, 92vw); border-radius:12px; box-shadow:0 8px 30px rgba(0,0,0,.25); overflow:hidden; padding: 20px;">
      <div style="display:flex; align-items:center; justify-content:space-between; padding:14px 16px; border-bottom:1px solid #eee;">
        <strong>Log in</strong>
        <button id="gdLoginClose" style="background:none;border:0;font-size:20px;line-height:1;cursor:pointer">×</button>
      </div>
      <div style="padding:16px">
        <form id="gdLoginForm" method="post" action="/account/login" accept-charset="UTF-8" novalidate>
          <input type="hidden" name="form_type" value="customer_login">
          <input type="hidden" name="return_to" id="gdReturnTo">
          <div style="display:flex; flex-direction:column; gap:10px;">
            <label style="display:flex; flex-direction:column; gap:6px;">
              <span>Email</span>
              <input required type="email" name="customer[email]" style="padding:10px;border:1px solid #ccc;border-radius:8px;">
            </label>
            <label style="display:flex; flex-direction:column; gap:6px;">
              <span>Password</span>
              <input required type="password" name="customer[password]" style="padding:10px;border:1px solid #ccc;border-radius:8px;">
            </label>
            <button type="submit" class="quick-comment-comment-btn" style="padding:10px;border-radius:10px;">Log in</button>
            <div style="font-size:12px;color:#777">You’ll be returned here after logging in.</div>
          </div>
        </form>
        <form id="gdSignupForm" method="post" action="/account" accept-charset="UTF-8" novalidate style="display:none;">
          <input type="hidden" name="form_type" value="create_customer">
          <div style="display:flex; flex-direction:column; gap:10px;">
            <label style="display:flex; flex-direction:column; gap:6px;">
              <span>First name</span>
              <input required type="text" name="customer[first_name]" style="padding:10px;border:1px solid #ccc;border-radius:8px;">
            </label>
            <label style="display:flex; flex-direction:column; gap:6px;">
              <span>Last name</span>
              <input required type="text" name="customer[last_name]" style="padding:10px;border:1px solid #ccc;border-radius:8px;">
            </label>
            <label style="display:flex; flex-direction:column; gap:6px;">
              <span>Email</span>
              <input required type="email" name="customer[email]" style="padding:10px;border:1px solid #ccc;border-radius:8px;">
            </label>
            <label style="display:flex; flex-direction:column; gap:6px;">
              <span>Password</span>
              <input required type="password" name="customer[password]" style="padding:10px;border:1px solid #ccc;border-radius:8px;">
            </label>
            <button type="submit" style="padding:10px;border-radius:10px;">Create account</button>
          </div>
        </form>

        <div id="gdLoginToggle" style="margin-top:12px; font-size:13px; text-align:center; cursor:pointer; color:#0070f3;">
          Don’t have an account? Create one
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const close = () => (modal.style.display = 'none');
  const loginForm  = modal.querySelector('#gdLoginForm');
  const signupForm = modal.querySelector('#gdSignupForm');
  const toggleLink = modal.querySelector('#gdLoginToggle');

  toggleLink.addEventListener('click', () => {
    const showingLogin = loginForm.style.display !== 'none';
    if (showingLogin) {
      loginForm.style.display = 'none';
      signupForm.style.display = 'block';
      toggleLink.textContent = 'Already have an account? Log in';
    } else {
      signupForm.style.display = 'none';
      loginForm.style.display = 'block';
      toggleLink.textContent = 'Don’t have an account? Create one';
    }
  });

  modal.querySelector('#gdLoginClose').addEventListener('click', close);
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.style.display !== 'none') close(); });

  // Resume handling (re-open product modal or any other action)
  function setResumeState(state) {
    try { sessionStorage.setItem('gd:resume', JSON.stringify(state || {})); } catch {}
  }
  function getResumeState() {
    try { return JSON.parse(sessionStorage.getItem('gd:resume') || '{}'); } catch { return {}; }
  }
  function clearResumeState() { try { sessionStorage.removeItem('gd:resume'); } catch {} }

  // Expose opener
  window.openLoginModal = function(resumeState) {
    // Store caller intent (e.g., reopen product modal with a productId)
    if (resumeState && typeof resumeState === 'object') setResumeState(resumeState);

    // Build return_to (full current URL incl query/hash)
    const here = window.location.href;
    const ret = modal.querySelector('#gdReturnTo');
    if (ret) ret.value = here;

    modal.style.display = 'flex';
  };

  // Delegated click handler for generic buttons/links
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-login-modal]');
    if (!btn) return;
    e.preventDefault();
    let resume = null;
    const raw = btn.getAttribute('data-login-resume');
    if (raw) { try { resume = JSON.parse(raw); } catch {} }
    window.openLoginModal(resume || {});
  });

  // On load after login, replay resume intent (and clear it)
  document.addEventListener('DOMContentLoaded', () => {
    const resume = getResumeState();
    if (resume && resume.type) {
      if (resume.type === 'openProductModal' && resume.productId && typeof window.openProductModal === 'function') {
        // reopen quick-view/preview for the product
        const p = window.productMap?.[resume.productId];
        if (p) window.openProductModal(p);
      }
      clearResumeState();
    }
  });
})();

// ── prevent certain callers from auto‐closing the sidebar ──
let suppressSidebarClose = false;

// track whether the compare tray is collapsed (must be global)
let isCompareTrayCollapsed = false;

// ── Setup Table / Grid toggle buttons (icons with active/inactive styling) ──
let isGridView = false;
const tableContainerEl = document.getElementById("tableContainer");
if (tableContainerEl) {
  // 1) Create grid wrapper (hidden by default)
  const gridContainerEl = document.createElement("div");
  gridContainerEl.id = "productGridContainer";
  gridContainerEl.style.display = "none";
  gridContainerEl.className = "product-grid";
  tableContainerEl.appendChild(gridContainerEl);

  // 2) Build two buttons: Table & Grid
  const rightControls = document.querySelector(".right-controls");
  if (rightControls) {
    const tableBtn = document.createElement("button");
    tableBtn.id = "showTableViewBtn";
    tableBtn.className = "view-toggle active";
    tableBtn.style.background = "#000";             // active = black
    const tableIcon = document.createElement("img");
    tableIcon.src    = "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/table-view.svg?v=1754122704";
    tableIcon.alt    = "Table View";
    // active icon: no invert
    tableBtn.appendChild(tableIcon);

    const gridBtn = document.createElement("button");
    gridBtn.id = "showGridViewBtn";
    gridBtn.className = "view-toggle";
    gridBtn.style.background = "#fff";              // inactive = white
    const gridIcon = document.createElement("img");
    gridIcon.src    = "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/grid-view.svg?v=1754122690";
    gridIcon.alt    = "Grid View";
    gridIcon.style.filter = "invert(1)";            // invert for inactive
    gridBtn.appendChild(gridIcon);

    // insert next to Dark Mode toggle if present
    const darkInput = document.getElementById("toggleDarkModeCheckbox");
    const darkLabel = darkInput?.closest("label.switch-toggle");
    if (darkLabel && darkLabel.parentNode === rightControls) {
      darkLabel.insertAdjacentElement("afterend", tableBtn);
      tableBtn.insertAdjacentElement("afterend", gridBtn);
    } else {
      rightControls.appendChild(tableBtn);
      rightControls.appendChild(gridBtn);
    }

    // 3) Wire up clicks
    tableBtn.addEventListener("click", () => {
      isGridView = false;
      window.isGridView = false;
      tableBtn.classList.add("active");
      gridBtn.classList.remove("active");

      // styling
      tableBtn.style.background = "#000";
      tableBtn.querySelector("img").style.filter = "none";
      gridBtn.style.background = "#fff";
      gridBtn.querySelector("img").style.filter = "invert(1)";

     updateProductView();
     // ── ensure Dark-Mode toggle is visible in table view ──
     if (darkLabel) darkLabel.style.display = "inline-flex";
    });

    gridBtn.addEventListener("click", () => {
      isGridView = true;
      window.isGridView = true;
      gridBtn.classList.add("active");
      tableBtn.classList.remove("active");

      // styling
      gridBtn.style.background = "#000";
      gridBtn.querySelector("img").style.filter = "none";
      tableBtn.style.background = "#fff";
      tableBtn.querySelector("img").style.filter = "invert(1)";

     updateProductView();
     // ── hide Dark-Mode toggle in grid/card view ──
     if (darkLabel) darkLabel.style.display = "none";
    });
  }
}

/**
 * Refreshes the “Showing X of Y <Products>” badge based on
 * the current #productsTableBody <tr> count & visibility.
 */
function refreshProductCounter() {
  const rows   = Array.from(document.querySelectorAll("#productsTableBody tr"));
  const total  = rows.length;
  const shown  = rows.filter(r => r.style.display !== "none").length;
  const badge  = document.getElementById("product-count-container");
  if (!badge) return;
  badge.textContent =
    shown < total
      ? `Showing ${shown} of ${total}`
      : `${total} ${currentProductType}`;
}


/**
 * Universal product context-menu (table or card).
 *
 * @param {MouseEvent} e The contextmenu event
 * @param {Object} baseProduct The product object
 * @param {Array} products The current products array (for “closest match” logic)
 */
function showProductContextMenu(e, baseProduct, products) {
  const isFullscreen = !!document.fullscreenElement;
  const isInScope   = !!e.target.closest("#tableContainer");
  if (isFullscreen && !isInScope) return;

  e.preventDefault();
  document.getElementById("rowContextMenu")?.remove();

  const menu = document.createElement("div");
  menu.id = "rowContextMenu";
  Object.assign(menu.style, {
    position:     "absolute",
    top:          `${e.pageY}px`,
    left:         `${e.pageX}px`,
    zIndex:       "9999",
    background:   "#fff",
    color:        "#000",
    border:       "1px solid #ccc",
    padding:      "10px",
    boxShadow:    "0 2px 6px rgba(0,0,0,0.2)",
    fontSize:     "14px",
    minWidth:     "200px",
    borderRadius: "5px",
    display:      "flex",
    flexDirection:"column",
    alignItems:   "flex-start"
  });

  // — Title —
  const titleEl = document.createElement("div");
  titleEl.textContent = getCleanProductTitle(baseProduct);
  Object.assign(titleEl.style, {
    fontWeight:   "500",
    fontSize:     "16px",
    marginLeft:   "10px",
    borderBottom: "1px solid #ccc",
    padding:      "4px 0"
  });
  menu.appendChild(titleEl);

  // — Panels wrapper —
  const panels = document.createElement("div");
  panels.style.display    = "flex";
  panels.style.alignItems = "flex-start";
  menu.appendChild(panels);

  // Left panel: image
  const imgPanel = document.createElement("div");
  imgPanel.style.margin = "0 0 0 5px";
  if (baseProduct.featuredImage?.url) {
    const img = document.createElement("img");
    img.src       = baseProduct.featuredImage.url;
    img.alt       = escapeHTML(baseProduct.title);
    img.style.maxWidth = "200px";
    img.style.display  = "block";
    imgPanel.appendChild(img);
  }
  panels.appendChild(imgPanel);

  // Right panel: items
  const itemsPanel = document.createElement("div");
  itemsPanel.style.display        = "flex";
  itemsPanel.style.flexDirection  = "column";
  itemsPanel.style.margin         = "auto 5px";
  panels.appendChild(itemsPanel);

  const makeItem = (label, onClick) => {
    const item = document.createElement("div");
    item.textContent = label;
    item.style.padding = "6px 12px";
    item.style.cursor  = "pointer";
    item.onmouseenter = () => item.style.background = "#eee";
    item.onmouseleave = () => item.style.background = "#fff";
    item.onclick = () => {
      onClick();
      menu.remove();
    };
    return item;
  };

  // 🔍 Find Closest Match
  itemsPanel.appendChild(
    makeItem("🔍 Find Closest Match", () => {
      let best = null, highest = -1;
      products.forEach((p) => {
        if (p.id === baseProduct.id) return;
        const score = calculateProductMatchPercent(baseProduct, p);
        if (score > highest) {
          highest = score;
          best = p;
        }
      });
      if (best) {
        selectedProductsForComparison = [ baseProduct, best ];
        openCompareModal();
      }
    })
  );

  // 📊 Compare Closest 3 Matches
  itemsPanel.appendChild(
    makeItem("📊 Compare Closest 3 Matches", () => {
      const matches = products
        .filter((p) => p.id !== baseProduct.id)
        .map((p) => ({ product: p, score: calculateProductMatchPercent(baseProduct, p) }))
        .sort((a,b) => b.score - a.score)
        .slice(0,3)
        .map((e) => e.product);

      selectedProductsForComparison = [ baseProduct, ...matches ].slice(0,4);
      saveComparisonToStorage();
      updateCompareTrayUI();
      updateMatchPercent();
      updateCompareDisabled();
      document.getElementById("compareBtn").click();
    })
  );

  // 👁️ Quick View
  itemsPanel.appendChild(
    makeItem("👁️ Quick View", () => openProductModal(baseProduct))
  );

  // ❤️ Add to Favourites
  itemsPanel.appendChild(
    makeItem(
      favoritedProducts.includes(baseProduct.id)
        ? "💔 Remove from Favourites"
        : "❤️ Add to Favourites",
      () => {
        const idx = favoritedProducts.indexOf(baseProduct.id);
        if (idx > -1) {
          favoritedProducts.splice(idx,1);
        } else {
          favoritedProducts.push(baseProduct.id);
        }
        saveLocal("favoritedProducts", favoritedProducts);
        document.dispatchEvent(new Event("favoritesUpdated"));
      }
    )
  );

  // 📐 Add to Size Check
  itemsPanel.appendChild(
    makeItem("📐 Add to Size Check", () => {
      if (baseProduct.productType === "Mousepads") {
        addPadToPreview(baseProduct);
        openPadSizePreviewModal();
      } else {
        alert("This preview is only available for mousepads.");
      }
    })
  );

  (document.fullscreenElement || document.body).appendChild(menu);
}

function getNumericPid(product) {
  // Prefer Shopify/GID/id, then strip to the numeric tail your API expects
  const raw = String(
    product?.shopifyId ||
    product?.gid ||
    product?.id ||
    ''
  ).match(/\d+/g);
  return raw ? raw.pop() : '';
}

function renderProductGrid(products) {
  const grid = document.getElementById("productGridContainer");
  if (!grid) return;
  grid.innerHTML = ""; // wipe old cards

  // --- normalize inputs (rows, ids, nodes, objects) -> product objects
const normalizeToProduct = (x) => {
  if (!x) return null;
  if (x && typeof x === 'object' && x.id && (x.featuredImage || x.tags || x.productType)) return x; // already product
  if (x && x.node && x.node.id) return x.node;       // GraphQL edge
  if (x.dataset?.productId) {                        // table row
    return window.productMap?.[x.dataset.productId] || null;
  }
  if (typeof x === 'string') {                        // string id
    const dec  = decodeURIComponent(x);
    const tail = x.match(/\d+/g)?.pop();
    return (
      window.productMap?.[x] ||
      window.productMap?.[dec] ||
      (tail ? window.productMap?.[tail] : null) ||
      null
    );
  }
  return null;
};

let input = Array.isArray(products) ? products : [];
let normalized = input.map(normalizeToProduct).filter(Boolean);

// Fallback: if caller passed only undefineds, rebuild from visible rows
if (!normalized.length && input.length) {
  const rows = Array.from(document.querySelectorAll('#productsTableBody tr[data-product-id]'))
    .filter(r => r.style.display !== 'none');
  normalized = rows
    .map(r => window.productMap?.[r.dataset.productId] || null)
    .filter(Boolean);
}

// Final guard: only keep items with an image so we don't crash
products = normalized.filter(p => p?.featuredImage?.url);

  const frag = document.createDocumentFragment();

  // 1–4: build all the cards
  products.forEach((product) => {
    const imgUrl = product.featuredImage?.url || "";
    const id     = product.id;
    const isFav  = favoritedProducts.includes(id);
    const isSel = selectedProductsForComparison.some(p => p.id === id);

    const title = typeof getCleanProductTitle === "function"
      ? getCleanProductTitle(product)
      : product.title || "";

    const specs = typeof getTopSpecs === "function"
      ? getTopSpecs(product)
      : [];
    const surface  = specs.find(s => s.label === "Surface")?.value     || "—";
    const glide    = specs.find(s => s.label === "Glide Type")?.value || "—";
    const firmness = specs.find(s => s.label === "Firmness")?.value   || "—";
    const texture  = specs.find(s => s.label === "Texture")?.value     || "—";

    const stitchedTag = (product.tags || []).find(t => t.startsWith("Stitched Edges_"));
    const stitched    = stitchedTag
      ? stitchedTag.replace("Stitched Edges_", "").trim()
      : "—";

    const pid = getNumericPid(product); // <- robust PID

    const card = document.createElement("div");
    card.className = "product-card";
    card.dataset.productId = id;
    if (isFav) card.classList.add("favorited-card");
    // re-apply compare highlight
    if (isSel) card.classList.add("selected-for-compare");

    // ✅ Correctly nested overlay structure (no stray </div>)
    card.innerHTML = `
      <div class="card-image">
        <img src="${imgUrl}" loading="lazy" alt="${title}">
        <div class="card-overlay">
          ${pid ? `
            <div class="overlay-rating" data-pid="${pid}" data-handle="${product.handle || ""}">
              <span class="stars" aria-label="Rating"></span>
              <span class="count"></span>
            </div>
          ` : ""}

          <div class="overlay-buttons">
            <button
              class="overlay-fav-btn"
              data-product-id="${id}"
              aria-label="Toggle Favorite"
              title="Favorite"
            >
              <span class="overlay-fav-icon ${isFav ? "favorited" : ""}">
                ${isFav ? "♥" : "♡"}
              </span>
            </button>

            <button
              class="overlay-quickview-btn"
              data-product-id="${id}"
              aria-label="Quick View"
              title="Quick View"
            >
              <img
                src="https://cdn.shopify.com/s/files/1/0102/8426/9615/files/eye.svg?v=1753342185"
                alt="Quick View"
              />
            </button>

            <label class="overlay-compare-label">
              <input
                type="checkbox"
                class="overlay-compare-toggle compare-toggle"
                data-product-id="${id}"
                ${isSel ? "checked" : ""}
              >
            </label>
          </div>

          <div class="overlay-content">
            <table><tbody>
              <tr><td><span>Surface:</span></td><td>${surface}</td></tr>
              <tr><td><span>Glide Type:</span></td><td>${glide}</td></tr>
              <tr><td><span>Firmness:</span></td><td>${firmness}</td></tr>
              <tr><td><span>Texture:</span></td><td>${texture}</td></tr>
              <tr><td><span>Stitched:</span></td><td>${stitched}</td></tr>
            </tbody></table>
          </div>
        </div>
      </div>

      <div class="card-content">
        <h3 class="card-title">${title}</h3>
      </div>
    `;

    card.addEventListener("contextmenu", e => {
      showProductContextMenu(e, product, products);
    });

    frag.appendChild(card);
  });

  grid.appendChild(frag);

 // Ask the global reviews module to hydrate card ratings (does nothing if absent)
 window.DB_REVIEWS?.hydrateCards?.(grid);

// Overlay Quick View icon click -> open modal
grid.querySelectorAll(".overlay-quickview-btn").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.stopPropagation(); // don't toggle compare via card click
    const pid = btn.dataset.productId;
    if (typeof openProductModalById === "function") {
      openProductModalById(pid);
    } else {
      const p = productMap[pid];
      if (p) openProductModal(p);
    }
  });
});

  // ── ensure our compare‐toggles & highlight‐classes match the JS state ──
  selectedProductsForComparison.forEach(({id: selId}) => {
    const cb = grid.querySelector(`.overlay-compare-toggle[data-product-id="${selId}"]`);
    if (cb) {
      cb.checked = true;
      cb.closest(".product-card")?.classList.add("selected-for-compare");
    }
  });

  // ─── 5) Compare‐toggle logic + 4-item limit ─────────────────────────────
  const toggles = grid.querySelectorAll(".overlay-compare-toggle");

  function updateCompareLimitUI() {
    const count = selectedProductsForComparison.length;
    toggles.forEach(cb => {
      // disable any *unchecked* boxes once we've hit 4
      const card = cb.closest(".product-card");
      if (!cb.checked && count >= 4) {
        cb.disabled = true;
        card.classList.add("disabled-for-compare");
      } else {
        cb.disabled = false;
        card.classList.remove("disabled-for-compare");
      }
    });
  }

  toggles.forEach((cb) => {
    cb.addEventListener("change", () => {
      // enforce 4-item max
      if (cb.checked && selectedProductsForComparison.length >= 4) {
        cb.checked = false;
        alert("You can only compare up to 4 products");
        return;
      }

      const pid = cb.dataset.productId;
      const product = allProducts.find((p) => p.id === pid);
      if (!product) return;

      const idx = selectedProductsForComparison.findIndex((p) => p.id === pid);
      if (cb.checked && idx === -1) {
        selectedProductsForComparison.push(product);
      } else if (!cb.checked && idx > -1) {
        selectedProductsForComparison.splice(idx, 1);
      }

      saveLocal("selectedComparisonProducts", selectedProductsForComparison);
      updateCompareTrayUI();
      updateCompareButtonsVisibility();

      const card = cb.closest(".product-card");
      card.classList.toggle("selected-for-compare", cb.checked);

      updateCompareLimitUI();
    });
  });

  updateCompareLimitUI();

  // ─── 6) Favorite‐button logic ───────────────────────────────────────────
  grid.querySelectorAll(".overlay-fav-btn").forEach((btn) => {
    const icon = btn.querySelector(".overlay-fav-icon");
    btn.addEventListener("click", (e) => {
      e.stopPropagation(); // don’t trigger the card click

      const pid = btn.dataset.productId;
      const idx = favoritedProducts.indexOf(pid);
      let isNowFav;

      if (idx === -1) {
        favoritedProducts.push(pid);
        isNowFav = true;
      } else {
        favoritedProducts.splice(idx, 1);
        isNowFav = false;
      }

      saveLocal("favoritedProducts", favoritedProducts);
      updateFavoritesUIVisibility();

      icon.textContent = isNowFav ? "♥" : "♡";
      icon.classList.toggle("favorited", isNowFav);

      const card = btn.closest(".product-card");
      card.classList.toggle("favorited-card", isNowFav);

      if (showingFavoritesOnly && !isNowFav) {
        card.remove();
      }
    });
  });

  // ─── 7) Whole‐card click toggles compare ───────────────────────────────
  grid.querySelectorAll(".product-card").forEach((card) => {
    card.style.cursor = "pointer";
    card.addEventListener("click", (e) => {
      // ignore clicks on the fav‐button or the checkbox label itself
      if (
        e.target.closest(".overlay-fav-btn") ||
        e.target.closest(".overlay-compare-label") ||
        e.target.closest(".card-quickview-btn")
      ) {
        return;
      }
      const cb = card.querySelector(".overlay-compare-toggle");
      if (!cb) return;

      // enforce limit here too
      if (!cb.checked && selectedProductsForComparison.length >= 4) {
        alert("You can only compare up to 4 products");
        return;
      }

      cb.checked = !cb.checked;
      cb.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
}

// Calculate offset for grid view height
function updateGridOffset() {
  // the three things above your grid
  const titleNav      = document.querySelector('.db-title-nav');
  const quickSearch   = document.getElementById('quick-search-container');
  const btnContainer  = document.querySelector('.button-container');

  let total = 0;
  [ titleNav, quickSearch, btnContainer ].forEach(el => {
    if (el && getComputedStyle(el).display !== 'none') {
      // include margins if you need them:
      const style = getComputedStyle(el);
      const h = el.getBoundingClientRect().height
              + parseFloat(style.marginTop)
              + parseFloat(style.marginBottom);
      total += h;
    }
  });

  // write into our CSS var
  document.documentElement.style.setProperty(
    '--grid-offset',
    `${total}px`
  );
}

window.addEventListener('resize', updateGridOffset);

// Show either the table or the grid, based on isGridView,
function updateProductView() {
  // close the Settings panel if it’s open
  const colPanel = document.getElementById('columnTogglePanel');
  if (colPanel && colPanel.style.transform === 'translateX(0px)') {
    toggleColumnPanel();
  }

  // close the Sidebar filter panel if it’s open
  const sidebarBtn = document.getElementById('toggleSidebarFilterBtn');
  if (
    !suppressSidebarClose &&
    sidebarBtn &&
    sidebarBtn.classList.contains('active')
  ) {
    sidebarBtn.click();
  }

  const tableWrapperEl = document.getElementById("tableWrapper");
  if (!tableWrapperEl) return;

  // toggle our “grid-view” class (ASCII hyphen!)
  tableWrapperEl.classList.toggle("grid-view", isGridView);

  const tableContent = document.getElementById("products-table-wrapper");
  const gridWrapper  = document.getElementById("productGridContainer");
  const btnContainer = tableWrapperEl.querySelector(".button-container");

  if (isGridView) {
    // hide table, show grid
    tableContent.style.display = "none";
    gridWrapper.style.display  = "";

    // render grid
    const visibleRows = Array.from(
      document.querySelectorAll("#productsTableBody tr")
    ).filter(r => r.style.display !== "none");
    renderProductGrid(visibleRows); // renderProductGrid now normalizes rows→products

    // recalc offset for sticky header
    updateGridOffset();

    // make grid scroll internally
    gridWrapper.classList.add("scrollable");

    // center the controls under the grid
    if (btnContainer) {
      const w = gridWrapper.getBoundingClientRect().width;
      btnContainer.style.width        = `${w}px`;
      btnContainer.style.margin       = "0 auto 1px";
      btnContainer.style.padding      = "0 0 20px";
      btnContainer.style.borderBottom = "1px solid #ccc";
    }

  } else {
    // back to table
    gridWrapper.style.display    = "none";
    tableContent.style.display   = "";

    gridWrapper.classList.remove("scrollable");
    if (btnContainer) {
      btnContainer.style.width        = "";
      btnContainer.style.margin       = "";
      btnContainer.style.padding      = "";
      btnContainer.style.borderBottom = "";
    }
  }
}


function initFullscreenToggle() {
  const fullscreenBtn = document.getElementById("fullscreenToggleBtn");
  const fullscreenContainer = document.getElementById("tableContainer");

  if (!fullscreenBtn) return;

  fullscreenBtn.style.removeProperty("display");
  fullscreenBtn.style.display = "block";

  if (fullscreenBtn.dataset.bound === "true") return;
  fullscreenBtn.dataset.bound = "true";

  const openIconURL =
    "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/fullscreen.svg?v=1750358987";
  const closeIconURL =
    "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/close-fullscreen.svg?v=1750359193";

  const img = document.createElement("img");
  img.alt = "Fullscreen Toggle";
  img.style.width = "20px";
  img.style.height = "20px";
  fullscreenBtn.innerHTML = "";
  fullscreenBtn.appendChild(img);

  const updateIcon = () => {
    img.src = document.fullscreenElement ? closeIconURL : openIconURL;
  };

  fullscreenBtn.addEventListener("click", () => {
    if (!document.fullscreenElement) {
      fullscreenContainer.requestFullscreen().catch((err) => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  });

  document.addEventListener("fullscreenchange", updateIcon);

  updateIcon();
}

function closeCompareModal() {
  const modal = document.getElementById("compareModal");
  if (modal) {
    modal.style.display = "none";  // Hide the modal
    document.body.classList.remove("modal-open");  // Optionally remove 'modal-open' class if used
  }
}

function updateFavoritesUIVisibility() {
  favoritedProducts = loadLocal("favoritedProducts", []);
  const hasFavorites = favoritedProducts.length > 0;
  const clearBtn = document.getElementById("clearFavoritesBtn");
  const saveBtn = document.getElementById("saveFavoritesListBtn");

  if (clearBtn)
    clearBtn.style.display = hasFavorites ? "inline-block" : "none";
  if (saveBtn) saveBtn.style.display = hasFavorites ? "inline-block" : "none";
}

function bindUIEvents() {
  document.addEventListener("favoritesUpdated", updateFavoritesUIVisibility);

  document.getElementById("compareBtn")?.addEventListener("click", () => {
    if (selectedProductsForComparison.length < 2) {
      alert("Please select at least two products to compare.");
      return;
    }
    openCompareModal();
  });

  document
    .getElementById("clearAllFiltersBtn")
    ?.addEventListener("click", () => {
      document
        .querySelectorAll(".filter-checkbox")
        .forEach((cb) => (cb.checked = false));
      document
        .querySelectorAll(".selected-filter")
        .forEach((sf) => (sf.textContent = ""));

      document
        .querySelectorAll(".sidebar-filter-checkbox")
        .forEach((cb) => (cb.checked = false));

      document
        .querySelectorAll(".sidebar-filter-select-all")
        .forEach((cb) => (cb.checked = false));

      document
        .querySelectorAll("[id^='sidebar-slider-']")
        .forEach((sliderEl) => {
          const safeName = sliderEl.id.replace("sidebar-slider-", "");
          const column = safeName.replace(/-/g, " ");
          const minInput = document.getElementById(`sidebar-min-${column}`);
          const maxInput = document.getElementById(`sidebar-max-${column}`);
          if (minInput && maxInput && sliderEl.noUiSlider) {
            const minDefault = parseFloat(minInput.min);
            const maxDefault = parseFloat(maxInput.max);

            sliderEl.noUiSlider.set([minDefault, maxDefault], false);

            minInput.value = minDefault;
            maxInput.value = maxDefault;

            updateClearButtonVisibility(column);
          }
        });

      const basePath = window.location.pathname;
      const typeQuery = currentProductType
        ? `?type=${encodeURIComponent(currentProductType)}`
        : "";
      history.replaceState(null, "", basePath + typeQuery);

      updateFilterButtonsVisibility();
      applyColumnFilters();
      updateSidebarOptionsBasedOnActiveFilters();
      updateGroupClearButtonVisibility();
      highlightFilteredColumns();
      updateProductView();
    });

  document
    .getElementById("closeCompareModal")
    ?.addEventListener("click", () => {
      document.getElementById("compareModal").style.display = "none";
      document.body.classList.remove("modal-open");
    });

  document
    .getElementById("toggleColumnSettingsBtn")
    ?.addEventListener("click", () => {
      const settingsModal = document.getElementById("columnSettingsModal");
      if (settingsModal) {
        settingsModal.style.display = "block";
      }
    });

  // ── FAVORITES‐ONLY TOGGLE ────────────────────────────
  const favToggle = document.getElementById("toggleFavoritesCheckbox");
  if (favToggle) {
    favToggle.addEventListener("change", (e) => {
      showingFavoritesOnly = e.target.checked;

      // 1) Remove any old "no-favourites" row
      document.getElementById("no-favorites-row")?.remove();

      // 2) Hide/Show table–rows
      document.querySelectorAll("#productsTableBody tr").forEach((row) => {
        const id = row.getAttribute("data-product-id");
        if (!id) return;
        row.style.display = showingFavoritesOnly
          ? (favoritedProducts.includes(id) ? "" : "none")
          : "";
      });

      // 3) Hide/Show grid–cards
      document.querySelectorAll("#productGridContainer .product-card").forEach((card) => {
        const pid = card.dataset.productId;
        card.style.display = showingFavoritesOnly
          ? (favoritedProducts.includes(pid) ? "" : "none")
          : "";
      });

      // 4) Fallback row in TABLE view
      if (
        showingFavoritesOnly &&
        !Array.from(document.querySelectorAll("#productsTableBody tr"))
          .some(r => r.style.display !== "none")
      ) {
        const tbody = document.getElementById("productsTableBody");
        const noRow = document.createElement("tr");
        noRow.id = "no-favorites-row";
        const td = document.createElement("td");
        td.colSpan = "100%";
        td.style.padding = "20px";
        td.textContent = "No favourites to display.";
        noRow.appendChild(td);
        tbody.appendChild(noRow);
      }

      // 5) Refresh UI buttons/counts
      updateFavoritesUIVisibility();
      updateCompareButtonsVisibility();
    });
  }

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  const searchInput = document.getElementById("quickSearch");
  if (searchInput) {
    // 1) extract the “hide/show + mark” logic into its own function
function applySearchFilter() {
  const query = searchInput.value.toLowerCase();
  const words = query.split(/\s+/).filter(Boolean);

  // build your filtered list
  const filteredBySearch = currentFilteredProducts.filter((product) => {
    const tagFields = getTagFieldsForType(currentProductType);
    const tagSpecs = tagFields.map((f) => {
      const tag = product.tags?.find((t) => t.startsWith(f.prefix));
      return tag ? tag.replace(f.prefix, "") : "";
    });
    const target = [
      product.title,
      product.vendor,
      ...(product.tags || []),
      ...tagSpecs,
    ]
      .join(" ")
      .toLowerCase();
    return words.every((w) => target.includes(w));
  });

  const tbody = document.querySelector("#productsTableBody");
  const allRows = tbody.querySelectorAll("tr[data-product-id]");

  // if query < 3 chars, just reset everything
  if (query.length < 3) {
    allRows.forEach((row) => {
      const id = row.getAttribute("data-product-id");
      row.style.display = currentFilteredProducts.some((p) => p.id === id)
        ? ""
        : "none";
      row.querySelectorAll("mark").forEach((mark) => {
        const p = mark.parentNode;
        p.replaceChild(document.createTextNode(mark.textContent), mark);
        p.normalize();
      });
    });
    refreshProductCounter();
    return;
  }

  // otherwise, hide/show + highlight
  allRows.forEach((row) => {
    const id = row.getAttribute("data-product-id");
    const match = filteredBySearch.some((p) => p.id === id);
    row.style.display = match ? "" : "none";

    // clear old <mark>
    row.querySelectorAll("mark").forEach((mark) => {
      const p = mark.parentNode;
      p.replaceChild(document.createTextNode(mark.textContent), mark);
      p.normalize();
    });

    if (match) {
      Array.from(row.cells).forEach((cell) => {
        const walker = document.createTreeWalker(
          cell,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );
        const texts = [];
        while (walker.nextNode()) texts.push(walker.currentNode);
        texts.forEach((tn) => {
          let html = tn.textContent;
          words.forEach((w) => {
            if (!w) return;
            const re = new RegExp(`(${escapeRegExp(w)})`, "gi");
            html = html.replace(re, "<mark>$1</mark>");
          });
          const span = document.createElement("span");
          span.innerHTML = html;
          tn.parentNode.replaceChild(span, tn);
        });
      });
    }
  });

  // handle “no results” fallback
  const fallbackId = "no-results-row";
  document.getElementById(fallbackId)?.remove();
  if (filteredBySearch.length === 0) {
    const tr = document.createElement("tr");
    tr.id = fallbackId;
    const td = document.createElement("td");
    td.colSpan = 100;
    td.textContent = "No products found.";
    td.style.padding = "16px";
    td.style.color = "var(--text-secondary)";
    tr.appendChild(td);
    tbody.appendChild(tr);
  }

refreshProductCounter();

  // if grid‐view, re-render it
  if (window.isGridView && typeof updateProductView === "function") {
    updateProductView();
  }
}

// 2) only run that when the user hits Enter
searchInput.addEventListener("keydown", (e) => {
  if (e.key === "Enter") {
    applySearchFilter();
  }
});

    const suggestionsBox = document.getElementById("liveSuggestions");

    searchInput.addEventListener("input", () => {
      const val = searchInput.value.trim().toLowerCase();
      const words = val.split(/\s+/).filter(Boolean);

      if (val.length < 3) {
        suggestionsBox.style.display = "none";
        return;
      }

      const matches = {
        brand: [],
        title: [],
        spec: [],
      };

      currentFilteredProducts.forEach((product) => {
        const tagFields = getTagFieldsForType(currentProductType);
        const tagSpecs = tagFields.map((f) => {
          const tag = product.tags?.find((t) => t.startsWith(f.prefix));
          return tag ? tag.replace(f.prefix, "") : "";
        });

        const targetFields = [
          product.title,
          product.vendor,
          ...(product.tags || []),
          ...tagSpecs,
        ]
          .join(" ")
          .toLowerCase();

        const match = words.every((word) => targetFields.includes(word));
        if (!match) return;

        if (product.vendor.toLowerCase().includes(val))
          matches.brand.push(product.vendor);
        if (product.title.toLowerCase().includes(val))
          matches.title.push(product.title);
        tagFields.forEach((field) => {
          const tag = product.tags?.find((t) => t.startsWith(field.prefix));
          if (tag) {
            const value = tag.replace(field.prefix, "").trim();
            if (value.toLowerCase().includes(val)) {
              matches.spec.push(`${field.label}: ${value}`);
            }
          }
        });
      });

      function renderSection(name, items) {
        if (!items.length) return "";

        const capped = items.slice(0, 5);
        const showToggle = items.length > 5;
        const sectionId = `suggest-${name}`;

        const listItems = capped
          .map((i) => {
            if (name === "spec" && i.includes(":")) {
              const [label, value] = i.split(":").map((s) => s.trim());
              return `<li data-type="${name}"><strong>${label}:</strong> ${value}</li>`;
            }
            return `<li data-type="${name}">${i}</li>`;
          })
          .join("");

        const extraItems = showToggle
          ? items
              .slice(5)
              .map(
                (i) =>
                  `<li data-type="${name}" class="extra ${sectionId}" style="display: none;">${i}</li>`
              )
              .join("")
          : "";

        const viewAllBtn = showToggle
          ? `<li class="view-all-toggle" data-expand="${sectionId}" data-expanded="false" style="cursor: pointer;">View all</li>`
          : "";

        return `
    <li class="suggestion-group-label">
      ${
        name === "title"
          ? "Products"
          : name.charAt(0).toUpperCase() + name.slice(1)
      }
    </li>
    ${listItems}
    ${extraItems}
    ${viewAllBtn}
  `;
      }

      const html =
        renderSection("brand", [...new Set(matches.brand)]) +
        renderSection("title", [...new Set(matches.title)]) +
        renderSection("spec", [...new Set(matches.spec)]);

      suggestionsBox.innerHTML = html;

      if (html) {
        const rect = searchInput.getBoundingClientRect();
        suggestionsBox.style.display = "block";
        suggestionsBox.style.top = `${window.scrollY + rect.bottom}px`;
        suggestionsBox.style.left = `${window.scrollX + rect.left}px`;
        suggestionsBox.style.width = `${rect.width}px`;
        suggestionsBox.style.position = "absolute";
        suggestionsBox.style.zIndex = "1";
      } else {
        suggestionsBox.style.display = "none";
      }
    });

// ─── suggestion dropdown click handler ─────────────────────────────
suggestionsBox.addEventListener("click", (e) => {
  const li = e.target.closest("li");
  if (!li || !suggestionsBox.contains(li)) return;

  // 1) “View all” button: show every hidden extra suggestion
  if (li.classList.contains("view-all-toggle")) {
    suggestionsBox
      .querySelectorAll("li.extra")
      .forEach(x => x.style.display = "list-item");
    return;
  }

  const type = li.dataset.type;
  const text = li.textContent.trim();

  // 2) SPEC click: exact‐match on that tag only
  if (type === "spec") {
    // split "Glide Type: Balanced" → ["Glide Type","Balanced"]
    const [label, val] = text.split(":").map(s => s.trim());
    // find the prefix for that label (e.g. "Surface Type__")
    const field = getTagFieldsForType(currentProductType).find(f => f.label === label);
    const prefix = field.prefix;
    // filter table‐rows
    document
      .querySelectorAll("#productsTableBody tr[data-product-id]")
      .forEach(row => {
        const prod = productMap[row.dataset.productId];
        const tagVal = prod.tags
          .find(t => t.startsWith(prefix))
          ?.replace(prefix, "")
          .trim();
        row.style.display = (tagVal === val) ? "" : "none";
      });
    // re‐render grid if needed
    if (window.isGridView) updateProductView();
    suggestionsBox.style.display = "none";
    return;
  }

  // 3) BRAND or TITLE click: fallback to your normal search
  if (type === "brand" || type === "title") {
    searchInput.value = text;
    clearSearchBtn.style.display = "inline";
    suggestionsBox.style.display = "none";
    applySearchFilter();
    if (window.isGridView) updateProductView();
  }
});

    document.addEventListener("click", (e) => {
      const isClickInside =
        searchInput.contains(e.target) || suggestionsBox.contains(e.target);
      if (!isClickInside) {
        suggestionsBox.style.display = "none";
      }
    });

    const clearSearchBtn = document.getElementById("clearSearchBtn");

    searchInput.addEventListener("input", () => {
      clearSearchBtn.style.display = searchInput.value ? "inline" : "none";
    });

    clearSearchBtn.addEventListener("click", () => {
      searchInput.value = "";
      clearSearchBtn.style.display = "none";
      applySearchFilter();            // ← reset the table
      suggestionsBox.style.display = "none";  // close suggestions

      // if we're currently in grid-view, re-render it:
      if (window.isGridView) {
        updateProductView();
      }
    });
  }

  const copyLinkBtn = document.getElementById("copyShareLinkBtn");
  if (copyLinkBtn) {
    copyLinkBtn.onclick = copyCurrentUrlToClipboard;
  }

  const shareBtn = document.getElementById("nativeShareBtn");
  if (shareBtn && navigator.share) {
    shareBtn.addEventListener("click", () => {
      navigator
        .share({
          title: document.title,
          text: "Check out this setup:",
          url: window.location.href,
        })
        .catch((err) => {
          console.warn("Share failed:", err);
        });
    });
  }

  const favoriteAllBtn = document.getElementById("favoriteAllBtn");
  if (favoriteAllBtn) {
    favoriteAllBtn.addEventListener("click", () => {
      // ——— TABLE VIEW ————————————————
      const visibleRows = document.querySelectorAll(
        "tbody tr:not([style*='display: none'])"
      );
      const visibleIds = Array.from(visibleRows).map((row) =>
        row.getAttribute("data-product-id")
      );

      favoritedProducts = [...new Set([...favoritedProducts, ...visibleIds])];
      saveLocal("favoritedProducts", favoritedProducts);
      saveLocal("savedFavoritesList", favoritedProducts);

      document.querySelectorAll(".favorite-btn").forEach((btn) => {
        const id = btn.dataset.id;
        if (favoritedProducts.includes(id)) {
          btn.textContent = "♥";
          btn.classList.add("favorited");
          btn.closest("tr")?.classList.add("row-favorited");
        }
      });
      document.dispatchEvent(new Event("favoritesUpdated"));

      // ——— GRID VIEW ————————————————
      document
        .querySelectorAll("#productGridContainer .overlay-fav-btn")
        .forEach((btn) => {
          const pid = btn.dataset.productId;
          if (favoritedProducts.includes(pid)) {
            // swap the heart icon
            const icon = btn.querySelector(".overlay-fav-icon");
            icon.textContent = "♥";
            icon.classList.add("favorited");
            // add the favourited-card class to shade the card
            const card = btn.closest(".product-card");
            if (card) card.classList.add("favorited-card");
          }
        });
    });
  }

  const clearFavoritesBtn = document.getElementById("clearFavoritesBtn");
  if (clearFavoritesBtn) {
    clearFavoritesBtn.addEventListener("click", () => {
      const visibleRows = document.querySelectorAll(
        "tbody tr:not([style*='display: none'])"
      );
      const visibleIds = Array.from(visibleRows).map((row) =>
        row.getAttribute("data-product-id")
      );

      favoritedProducts = favoritedProducts.filter(
        (id) => !visibleIds.includes(id)
      );
      saveLocal("favoritedProducts", favoritedProducts);
      saveLocal("savedFavoritesList", favoritedProducts);

      if (favoritedProducts.length === 0) {
        activeFavoriteName = null;
        renderSavedFavorites();
      }

      visibleRows.forEach((row) => {
        const id = row.getAttribute("data-product-id");
        if (!favoritedProducts.includes(id)) {
          const btn = row.querySelector(".favorite-btn");
          if (btn) {
            btn.textContent = "♡";
            btn.classList.remove("favorited");
          }
          row.classList.remove("row-favorited");
        }
      });

      updateFavoritesToggleUI();
      document.dispatchEvent(new Event("favoritesUpdated"));

      updateProductView();
    });
  }

  document.querySelectorAll(".favorite-btn").forEach((btn) => {
    const productId = btn.dataset.id;
    if (favoritedProducts.includes(productId)) {
      btn.textContent = "♥";
      btn.classList.add("favorited");
      btn.closest("tr")?.classList.add("row-favorited");
    } else {
      btn.textContent = "♡";
      btn.classList.remove("favorited");
      btn.closest("tr")?.classList.remove("row-favorited");
    }

    btn.addEventListener("click", () => {
      const isFav = favoritedProducts.includes(productId);
      if (isFav) {
        favoritedProducts = favoritedProducts.filter((id) => id !== productId);
      } else {
        favoritedProducts.push(productId);
      }
      saveLocal("favoritedProducts", favoritedProducts);
      saveLocal("savedFavoritesList", favoritedProducts);

      btn.textContent = isFav ? "♡" : "♥";
      btn.classList.toggle("favorited", !isFav);
      btn.closest("tr")?.classList.toggle("row-favorited", !isFav);

      updateFavoritesToggleUI();
      document.dispatchEvent(new Event("favoritesUpdated"));
    });
  });


  document.querySelectorAll(".compare-toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      const id = btn.dataset.productId;
      const product = allProducts.find((p) => p.id === id);
      if (!product) return;

      const index = selectedProductsForComparison.findIndex((p) => p.id === id);
      if (index >= 0) {
        selectedProductsForComparison.splice(index, 1);
        btn.classList.remove("active");
      } else {
        selectedProductsForComparison.push(product);
        btn.classList.add("active");
      }

      saveLocal("selectedComparisonProducts", selectedProductsForComparison);
      updateCompareTrayUI();
    });
  });
  
  // ── MANUAL COLLAPSE/EXPAND BINDING ──
  const tray      = document.getElementById("compareTray");
  const toggleBtn = document.getElementById("toggleCompareTrayBtn");
  if (tray && toggleBtn) {
    // clone the button to strip any old listeners
    const cleanBtn = toggleBtn.cloneNode(true);
    toggleBtn.parentNode.replaceChild(cleanBtn, toggleBtn);

    cleanBtn.addEventListener("click", () => {
      // flip our flag
      isCompareTrayCollapsed = !isCompareTrayCollapsed;

      // immediately apply
      tray.classList.toggle("collapsed", isCompareTrayCollapsed);

      // update the toggle text
      cleanBtn.textContent = isCompareTrayCollapsed ? "Compare ▲" : "▼";
    });
  }
}

function updateFilterButtonsVisibility() {
  const filters = Array.from(document.querySelectorAll(".selected-filter"));
  const anyMainFilter = filters.some((f) => f.textContent.trim() !== "");

  const anySidebarFilter = Array.from(
    document.querySelectorAll(".sidebar-filter-checkbox")
  ).some((cb) => cb.checked);

  const params = new URLSearchParams(window.location.search);
  const anyRangeFilter = Array.from(params.keys()).some(
    (key) => key.endsWith("_min") || key.endsWith("_max")
  );

  const anyFilterApplied = anyMainFilter || anySidebarFilter || anyRangeFilter;

  const filterBtn = document.getElementById("clearAllFiltersBtn");
  const copyBtn   = document.getElementById("copyShareLinkBtn");
  const shareBtn  = document.getElementById("nativeShareBtn");

  if (filterBtn) filterBtn.style.display = anyFilterApplied ? "inline-block" : "none";
  if (copyBtn)   copyBtn.style.display   = anyFilterApplied ? "inline-block" : "none";

  // show shareBtn only if the API exists AND at least one filter is applied
  if (shareBtn) {
    shareBtn.style.display = (navigator.share && anyFilterApplied)
      ? "inline-block"
      : "none";
  }
}

function updateCompareButtonsVisibility() {
  const compareBtn = document.getElementById("compareBtn");
  const clearSelBtn = document.getElementById("clearSelectionBtn");
  const count = selectedProductsForComparison.length;

  if (compareBtn)
    compareBtn.style.display = count >= 2 ? "inline-block" : "none";
  if (clearSelBtn)
    clearSelBtn.style.display = count > 0 ? "inline-block" : "none";
}

function updateFavoritesToggleUI() {
  const favToggle = document.getElementById("toggleFavoritesCheckbox");
  const favLabel = document.querySelector(".switch-toggle");
  const productCountContainer = document.getElementById(
    "product-count-container"
  );

  const clearBtn = document.getElementById("clearFavoritesBtn");
  const saveBtn = document.getElementById("saveFavoritesListBtn");

  if (!favToggle || !productCountContainer) return;

  const base = allProducts.filter(
    (p) => p.productType === currentProductType && !p.tags.includes("Open Box")
  );

  const favoriteProducts = base.filter((p) => favoritedProducts.includes(p.id));

  if (favToggle.checked) {
    favLabel?.classList.add("favorite-active");
    productCountContainer.textContent = `Showing ${favoriteProducts.length} favorites`;
  } else {
    favLabel?.classList.remove("favorite-active");
    productCountContainer.textContent = `${base.length} ${currentProductType}`;
  }

  const showButtons = favoritedProducts.length > 0;
  if (clearBtn) clearBtn.style.display = showButtons ? "inline-block" : "none";
  if (saveBtn) saveBtn.style.display = showButtons ? "inline-block" : "none";
}
// ─── Back-compat alias ───
window.updateFavoriteButtonsVisibility = updateFavoritesToggleUI;

// keep as-is, but capture the canonical id and pass it through
function openProductModal(shallowProduct, opts = {}) {
  const canonicalId = shallowProduct.shopifyId || shallowProduct.id; // <- your reviews key
  const handle = shallowProduct.handle || shallowProduct.onlineStoreUrl.split("/").pop();

  fetch(`/products/${handle}.js`)
    .then((res) => res.json())
    .then((fullProduct) => {
      // preserve the canonical id we started with
      fullProduct._canonicalId = canonicalId;
      showQuickViewModal(fullProduct, canonicalId, opts);
    })
    .catch((err) => {
      console.error("Failed to load full product data:", err);
      // still pass the canonical id
      showQuickViewModal(shallowProduct, canonicalId);
    });
}

function showQuickViewModal(product, canonicalId, opts = {}) {
  const modal = document.getElementById("productModal");
  const content = document.getElementById("productModalContent");
  const storeUrl =
    product.onlineStoreUrl ||
    (typeof product.url === "string" ? product.url : "");
  const productType = product.productType ?? product.type ?? "";
  const images = (() => {
    if (
      Array.isArray(product.images) &&
      product.images.every((i) => typeof i === "string")
    ) {
      return product.images;
    }
    if (Array.isArray(product.images?.edges)) {
      return product.images.edges.map((e) => e.node.url);
    }
    if (product.featured_image) {
      return [product.featured_image];
    }
    if (product.featuredImage?.url) {
      return [product.featuredImage.url];
    }
    return [];
  })();
  let variant;
  if (Array.isArray(product.variants)) {
    variant = product.variants[0] || {};
  } else if (Array.isArray(product.variants?.edges)) {
    variant = product.variants.edges[0]?.node || {};
  } else {
    variant = {};
  }

  const rawPriceInput = variant.price?.amount ?? variant.price ?? "0";
  const rawPriceString = String(rawPriceInput).trim();
  const priceValue = rawPriceString.includes(".")
    ? parseFloat(rawPriceString)
    : parseFloat(rawPriceString) / 100;
  const priceFormatted = priceValue.toFixed(2);

  let available = false;
  if (typeof product.availableForSale === "boolean") {
    available = product.availableForSale;
  } else if (typeof variant.available === "boolean") {
    available = variant.available;
  } else if (typeof variant.inventory_quantity === "number") {
    available = variant.inventory_quantity > 0;
  }

  const tagsArray = Array.isArray(product.tags)
    ? product.tags
    : typeof product.tags === "string"
    ? product.tags.split(/\s*,\s*/).map((t) => t.trim())
    : [];
  const tagFields = getTagFieldsForType(productType);
  const dimTag = tagsArray.find((t) => t.startsWith("Dims__"));
  const dimParts = dimTag
    ? dimTag
        .replace("Dims__", "")
        .replace(/mm/gi, "")
        .split(/[x×]/)
        .map((v) => v.trim())
    : [];
  const specGroups = {
    Dimensions: ["Length (mm)", "Width (mm)", "Thickness (mm)"],
    Performance: [
      "Surface",
      "Glide Type",
      "Firmness",
      "Texture",
      "Coating",
      "Static Friction",
      "Dynamic Friction",
    ],
    "Base & Build": ["Base", "Stitched", "Washable", "Packaged"],
    Style: ["Colour", "Graphics", "Lighting"],
    "Good to know": ["Game Type", "Warranty"],
  };

  const dimsFields = ["Length (mm)", "Width (mm)", "Thickness (mm)"];

  content.innerHTML = `
    <span id="closeModal" class="close">&times;</span>
    <div class="modal-content-flex">
      <div class="modal-left">
 ${
   images.length
     ? `<div class="quickview-carousel">
       <div class="slide-viewport">
         <!-- Main slides container -->
         <div class="slides">
           ${images
             .map(
               (url, i) => `
             <img src="${url}"
                  class="carousel-slide${i === 0 ? " active" : ""}"
                  data-index="${i}" />
           `
             )
             .join("")}
         </div>

         <!-- Prev/Next -->
         ${
           images.length > 1
             ? `<button class="carousel-prev">&lsaquo;</button>
             <button class="carousel-next">&rsaquo;</button>`
             : ""
         }

         <!-- Thumbnails row -->
         <div class="thumbnails">
           ${images
             .map(
               (url, i) => `
             <img src="${url}"
                  class="thumbnail${i === 0 ? " active-thumb" : ""}"
                  data-index="${i}" />
           `
             )
             .join("")}
         </div>
         </div>
       </div>`
     : ``
 }
      </div>
      <div class="modal-right">
        <h2>${escapeHTML(product.title)}</h2>
${priceValue === 0 ? "" : `<p class="price">£${priceFormatted}</p>`}
${available
  ? `<p><span class="inventory inventory--high">
      <img src="https://cdn.shopify.com/s/files/1/0102/8426/9615/files/arrow-up-circle_24x24_1x_1.svg?v=1602338544" height="20px" width="20px" alt="In Stock" title="In Stock"> In stock
    </span></p>`
  : ""}
        <div class="modal-footer">
<div class="product-spec-groups" id="quickviewSpecContainer">
${Object.entries(specGroups)
  .map(
    ([groupName, labels], gi) => `
 <div class="spec-group${gi === 0 ? " open" : ""}">
    <button class="toggle-spec-group">
      ${groupName} <span class="icon">${gi === 0 ? "▲" : "▼"}</span>
    </button>
<div class="group-content">
  <table class="spec-table">
    <tbody>
      ${labels
        .map((label) => {
          let val = "—";
          if (label === "Length (mm)") {
            val = dimParts[0] || "—";
          } else if (label === "Width (mm)") {
            val = dimParts[1] || "—";
          } else if (label === "Thickness (mm)") {
            val = dimParts[2] ? parseFloat(dimParts[2]).toFixed(1) : "—";
          } else {
            const f = tagFields.find((f) => f.label === label);
            const rawTag = f && tagsArray.find((t) => t.startsWith(f.prefix));
            if (rawTag) val = rawTag.replace(f.prefix, "").trim();
          }

          if (label === "Colour") {
            const parts = val.split(/\s*•\s*|\s*,\s*|\s*\/\s*/);
            const cssParts = parts.map((p) => colourMap[p] || p.toLowerCase());
            const swatchHtml = cssParts
              .map(
                (c) =>
                  `<div class="colour-half" style="background:${c};"></div>`
              )
              .join("");

            return `
            <tr>
              <td class="spec-name">Colour</td>
              <td class="spec-val">
                <div class="colour-block sidebar-colour-swatch">
                  ${swatchHtml}
                </div>
                <span style="margin-left:6px">${escapeHTML(val)}</span>
              </td>
            </tr>
          `;
          }

          return `
          <tr>
            <td class="spec-name">${escapeHTML(label)}</td>
            <td class="spec-val">${escapeHTML(val)}</td>
          </tr>
        `;
        })
        .join("")}
    </tbody>
  </table>
</div>

  </div>
`
  )
  .join("")}
</div>
          <button class="modal-link" onclick="window.open('${storeUrl}', '_blank')">
            More Details
          </button>
          <button class="modal-link" id="openSizeCheckerBtn">
            📐 Check Size
          </button>
        </div>
      </div>
    </div>
  `;

  content.querySelectorAll(".spec-group").forEach((grp) => {
    const btn = grp.querySelector(".toggle-spec-group");
    const contentEl = grp.querySelector(".group-content");
    const icon = btn.querySelector(".icon");

    btn.addEventListener("click", () => {
      const grp = btn.closest(".spec-group");
      const isOpen = grp.classList.toggle("open");
      icon.textContent = isOpen ? "▲" : "▼";
    });
  });

const carousel = content.querySelector(".quickview-carousel");
if (carousel) {
  let idx = 0;
  const slides = Array.from(carousel.querySelectorAll(".carousel-slide"));
  const slidesContainer = carousel.querySelector(".slides");
  const slideCount = slides.length;

  const prev = carousel.querySelector(".carousel-prev");
  const next = carousel.querySelector(".carousel-next");
  const thumbs = Array.from(carousel.querySelectorAll(".thumbnail"));

  function update() {
    // Update the position of the slides container to show the current slide
    slidesContainer.style.transform = `translateX(-${idx * 100}%)`; // Move by 100% each time

    // Update thumbnail active states
    thumbs.forEach((t, i) => {
      t.classList.toggle("active-thumb", i === idx);
    });

    // Scroll active thumbnail into view, centered
    const active = thumbs[idx];
    if (active) {
      active.scrollIntoView({
        behavior: "smooth",
        inline: "center",  // Center the active thumbnail
        block: "nearest",
      });
    }

    // Toggle visibility of arrows based on the slide position
    if (next) {
      if (idx === slideCount - 1) {
        next.style.display = "none";  // Hide "Next" button
      } else {
        next.style.display = "block"; // Show "Next" button
      }
    }

    if (prev) {
      if (idx === 0) {
        prev.style.display = "none";  // Hide "Prev" button
      } else {
        prev.style.display = "block"; // Show "Prev" button
      }
    }
  }

  update();

  if (prev && next && slideCount > 1) {
    prev.addEventListener("click", () => {
      idx = (idx - 1 + slideCount) % slideCount;
      update();
    });

    next.addEventListener("click", () => {
      idx = (idx + 1) % slideCount;
      update();
    });
  }

  thumbs.forEach((t) => {
    t.addEventListener("click", () => {
      idx = parseInt(t.dataset.index, 10);
      update();
    });
  });
}

// === REVIEWS + COMMENTS (SAFE + NORMALISED) ================================
const discussion = document.createElement('div');
discussion.id = 'quick-discussion-wrapper';

const xpBlock = document.createElement('div');
xpBlock.className = 'notification__block';
xpBlock.innerHTML = `<strong>Earn XP/Rewards</strong> by posting reviews & comments</a>`;
discussion.appendChild(xpBlock);

// Tab buttons
const tabBar = document.createElement('div');
tabBar.className = 'discussion-tab-bar';
tabBar.innerHTML = `
  <button class="discussion-tab active" data-tab="reviews">Reviews</button>
  <button class="discussion-tab" data-tab="comments">Q&A / Discuss</button>
`;
discussion.appendChild(tabBar);

// Reviews wrapper (first)
const reviewWrapper = document.createElement('div');
reviewWrapper.id = 'quick-review-wrapper';
reviewWrapper.style.width = '100%';
discussion.appendChild(reviewWrapper);

// Comments wrapper (second)
const commentsContainer = document.createElement('div');
commentsContainer.id = 'quick-comments-container';
commentsContainer.style.width = '100%';
commentsContainer.style.marginTop = '24px';
discussion.appendChild(commentsContainer);

content.appendChild(discussion);

commentsContainer.style.display = 'none';

// ---- NORMALISE PRODUCT ID (table + card compatible) ----
// always prefer the canonicalId you passed into this function
const pidForReviews = String(
  canonicalId ||
  product?.shopifyId ||
  product?.id ||
  product?.gid ||
  ''
).match(/\d+$/)?.[0] || '';  // numeric tail only (what your API expects)

// ---- Collect basic meta for the widget (title/handle/image) ----
const root = content || document;
const imgEl =
  root.querySelector('.quickview-carousel img') ||
  root.querySelector('img[data-role="main-image"]') ||
  root.querySelector('img[src*="/products/"]');

const productMeta = {
  title:  product?.title  || '',
  handle: product?.handle || '',
  image_url:
    (imgEl && (imgEl.currentSrc || imgEl.src)) ||
    product?.featuredImage?.url ||
    product?.featured_image?.src ||
    (Array.isArray(product?.images) && product.images[0]) ||
    (product?.images?.edges && product.images.edges[0]?.node?.url) ||
    product?.image || ''
};

// Expose meta for db-reviews.js
reviewWrapper.dataset.productId     = pidForReviews;
reviewWrapper.dataset.productTitle  = productMeta.title;
reviewWrapper.dataset.productHandle = productMeta.handle;
reviewWrapper.dataset.productImage  = productMeta.image_url;

// Clear on re-open (defensive)
reviewWrapper.innerHTML = '';
commentsContainer.innerHTML = '';

// ---- Tab logic ----
if (pidForReviews) {
  injectReviewSection(reviewWrapper, pidForReviews);
  renderQuickViewReviews(pidForReviews, content);
} else {
  reviewWrapper.innerHTML = '<div class="text-small-4">Reviews unavailable.</div>';
}

// Force default tab if requested
if (opts.defaultTab === "comments") {
  // switch active button
  tabBar.querySelectorAll('.discussion-tab').forEach(b =>
    b.classList.toggle('active', b.dataset.tab === 'comments')
  );
  reviewWrapper.style.display = 'none';
  commentsContainer.style.display = '';
  if (!commentsContainer._loaded) {
    initCommentsWidget(commentsContainer, pidForReviews || '', productMeta);
    commentsContainer._loaded = true;
  }
}

// Toggle handling
tabBar.addEventListener('click', (e) => {
  const btn = e.target.closest('.discussion-tab');
  if (!btn) return;

  // active state
  tabBar.querySelectorAll('.discussion-tab').forEach(b =>
    b.classList.toggle('active', b === btn)
  );

  if (btn.dataset.tab === 'reviews') {
    reviewWrapper.style.display   = '';
    commentsContainer.style.display = 'none';
  } else {
    reviewWrapper.style.display   = 'none';
    commentsContainer.style.display = '';
    if (!commentsContainer._loaded) {
      initCommentsWidget(commentsContainer, pidForReviews || '', productMeta);
      commentsContainer._loaded = true;
    }
  }
});

// ---- Focus param support (profile/activity deep links) ----
const urlParams = new URLSearchParams(location.search);
const focus = urlParams.get('focus'); // e.g. "comment:123" or "review:456"

if (focus) {
  const [type, id] = focus.split(':');

  if (type === 'comment') {
    // Force open Q&A / Discuss tab
    tabBar.querySelectorAll('.discussion-tab').forEach(b =>
      b.classList.toggle('active', b.dataset.tab === 'comments')
    );
    reviewWrapper.style.display = 'none';
    commentsContainer.style.display = '';

    if (!commentsContainer._loaded) {
      initCommentsWidget(commentsContainer, pidForReviews || '', productMeta);
      commentsContainer._loaded = true;
    }

    // Wait for render then scroll + highlight
    setTimeout(() => {
      const target = commentsContainer.querySelector(`[data-id="${id}"]`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        target.classList.add('focus-highlight');
      }
    }, 800);
  }

  if (type === 'review') {
    const doScroll = () => {
      const target = document.querySelector(`.review[data-id="${id}"]`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        target.classList.add('focus-highlight');
        setTimeout(() => target.classList.remove('focus-highlight'), 2000);
        window.removeEventListener('gd:reviews-hydrated', doScroll);
      }
    };

    // Wait for reviews to hydrate
    window.addEventListener('gd:reviews-hydrated', doScroll);

    // Also run once in case hydration already happened
    setTimeout(doScroll, 1200);
  }
}

// === END REVIEWS BLOCK ======================================================

  modal.style.display = "flex";
  document
    .getElementById("openSizeCheckerBtn")
    ?.addEventListener("click", () => {
      addPadToPreview(product);
      modal.style.display = "none";
      openPadSizePreviewModal();
    });

  document.getElementById("closeModal").onclick = () =>
    (modal.style.display = "none");

  modal.setAttribute("aria-modal", "true");
  modal.setAttribute("role", "dialog");
  modal.setAttribute("tabindex", "-1");
  modal.focus();

  const focusableSelectors =
    "a[href], area[href], input:not([disabled]), select:not([disabled]), " +
    'textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const focusableElems = Array.from(modal.querySelectorAll(focusableSelectors));
  const firstFocusable = focusableElems[0];
  const lastFocusable = focusableElems[focusableElems.length - 1];

  function handleKeyDown(e) {
    if (e.key === "Escape") {
      modal.style.display = "none";
      document.removeEventListener("keydown", handleKeyDown);
    }
    if (e.key === "Tab") {
      if (e.shiftKey && document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }
  document.addEventListener("keydown", handleKeyDown);
}

function updateCompareTrayUI() {
  const tray = document.getElementById("compareTray");
  const items = document.getElementById("compareTrayItems");
  const toggleBtn = document.getElementById("toggleCompareTrayBtn");
  if (!tray || !items) return;

  if (selectedProductsForComparison.length === 0) {
    tray.classList.remove("show");
    return;
  }

  tray.classList.add("show");

  items.innerHTML = selectedProductsForComparison
    .map((product) => {
      const img = product.featuredImage?.url || "";
      const title = getCleanProductTitle(product);
      const specs = getTopSpecs(product);

      return `
      <div class="trey-compare-card" data-id="${product.id}">
        <button class="trey-remove-btn" title="Remove">×</button>
        <img src="${img}" alt="${title}" />
        <div class="trey-compare-info">
          <div class="trey-compare-title">${title}</div>
          <ul class="trey-compare-specs">
            ${specs
              .map((s) => `<li>${s.label} <strong>${s.value}</strong></li>`)
              .join("")}
          </ul>
        </div>
      </div>
    `;
    })
    .join("");

  items.querySelectorAll(".trey-remove-btn").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const card = btn.closest(".trey-compare-card");
      const id = card?.dataset.id;
      if (!id) return;

      selectedProductsForComparison = selectedProductsForComparison.filter(
        (p) => p.id !== id
      );
      saveLocal("selectedComparisonProducts", selectedProductsForComparison);

      const checkbox = document.querySelector(
        `.compare-checkbox[data-product-id="${id}"]`
      );
      if (checkbox) checkbox.checked = false;

      const toggleBtn = document.querySelector(
        `.compare-toggle[data-product-id="${id}"]`
      );
      if (toggleBtn) toggleBtn.classList.remove("active");

      const row = document.querySelector(`tr[data-product-id="${id}"]`);
      if (row) {
        row.classList.remove("row-selected");
        Array.from(row.children).forEach((cell) =>
          cell.classList.remove("highlight-diff")
        );
      }

      updateCompareButtonsVisibility();

      document.querySelectorAll("tr[data-product-id]").forEach((row) => {
        row.classList.remove("row-disabled");
      });

      if (selectedProductsForComparison.length >= 4) {
        document.querySelectorAll("tr[data-product-id]").forEach((row) => {
          const id = row.dataset.productId;
          const isSelected = selectedProductsForComparison.some(
            (p) => p.id === id
          );
          if (!isSelected) row.classList.add("row-disabled");
        });
      }

      updateCompareButtonsVisibility();
      updateMatchPercent();
      updateCompareTrayUI();
      activeComparisonName = null;
      renderSavedComparisons();
    });
  });

  // === DRAW COLLAPSE/EXPAND UI HERE ===
  tray.classList.toggle("collapsed", isCompareTrayCollapsed);
  if (toggleBtn) {
    toggleBtn.textContent = isCompareTrayCollapsed ? "Compare ▲" : "▼";
  }

}

function getTopSpecs(product) {
  const specMap = {
    "Surface Material_": "Surface",
    "Surface Type__": "Glide Type",
    Firmness__: "Firmness",
    "Surface Texture__": "Texture",
    "Base Material__": "Base",
  };

  const topSpecs = [];

  for (const prefix in specMap) {
    const label = specMap[prefix];
    const tag = (product.tags || []).find((t) => t.startsWith(prefix));
    if (tag) {
      topSpecs.push({ label, value: tag.replace(prefix, "").trim() });
    }
  }
  return topSpecs;
}

function initDarkModeToggle() {
  const htmlEl             = document.documentElement;
  const bodyEl             = document.body;
  const productsWrapper    = document.getElementById("products-table-wrapper");
  const mainWrapper        = document.getElementById("mainContentWrapper");
  const darkCheckbox       = document.getElementById("toggleDarkModeCheckbox");
  const darkContainer      = darkCheckbox?.closest(".switch-toggle");

  // read stored:
  const wasDark = loadLocal("darkMode", false);

  // on load, set BOTH:
  htmlEl.classList.toggle("dark-bg",  wasDark);
  [ bodyEl, productsWrapper, mainWrapper ].forEach(el => {
    if (el) el.classList.toggle("dark-mode", wasDark);
  });
  if (darkCheckbox) darkCheckbox.checked = wasDark;
  if (darkContainer) darkContainer.style.display = "inline-flex";

  // when the user flips the switch:
  darkCheckbox?.addEventListener("change", () => {
    const nowDark = darkCheckbox.checked;
    saveLocal("darkMode", nowDark);

    htmlEl.classList.toggle("dark-bg", nowDark);
    [ bodyEl, productsWrapper, mainWrapper ].forEach(el => {
      if (el) el.classList.toggle("dark-mode", nowDark);
    });
  });
}

window.initDarkModeToggle = initDarkModeToggle;

function bindStaticUIEvents() {
  // 1) Clear Compare Tray
  document.getElementById("clearTrayBtn")?.addEventListener("click", () => {
    selectedProductsForComparison = [];
    saveLocal("selectedComparisonProducts", []);

    document
      .querySelectorAll(".compare-checkbox")
      .forEach((cb) => (cb.checked = false));
    document
      .querySelectorAll(".compare-toggle")
      .forEach((btn) => btn.classList.remove("active"));
    document.querySelectorAll("tr[data-product-id]").forEach((row) => {
      row.classList.remove("row-selected", "row-disabled");
      Array.from(row.children).forEach((cell) =>
        cell.classList.remove("highlight-diff")
      );
    });

    updateMatchPercent();
    updateCompareButtonsVisibility();
    updateCompareTrayUI();
    activeComparisonName = null;
    renderSavedComparisons();
    updateProductView();
  });

    // ── “Compare” button inside the tray ────────────────────────────────────
  document
    .getElementById("compareTrayBtn")
    ?.addEventListener("click", (e) => {
      e.preventDefault();
      if (selectedProductsForComparison.length < 2) {
        showToast("Please select at least two products to compare.");
        return;
      }
      openCompareModal();
    });

  // 2) Toggle visibility of Clear/Save Favourites buttons
  document.addEventListener("favoritesUpdated", () => {
    const clearBtn = document.getElementById("clearFavoritesBtn");
    const saveBtn = document.getElementById("saveFavoritesListBtn");
    const visible = favoritedProducts.length > 0;

    if (clearBtn) clearBtn.style.display = visible ? "inline-flex" : "none";
    if (saveBtn) saveBtn.style.display = visible ? "inline-flex" : "none";
  });

  // 3) Notes/Changelog/Request panels
  document.getElementById("notesLink")?.addEventListener("click", (e) => {
    e.preventDefault();
    const panel = document.getElementById("notesPanel");
    const other1 = document.getElementById("changelogPanel");
    const other2 = document.getElementById("requestPanel");
    panel.style.display = panel.style.display === "block" ? "none" : "block";
    other1.style.display = "none";
    other2.style.display = "none";
  });
  document.getElementById("changelogLink")?.addEventListener("click", (e) => {
    e.preventDefault();
    const panel = document.getElementById("changelogPanel");
    const other1 = document.getElementById("notesPanel");
    const other2 = document.getElementById("requestPanel");
    panel.style.display = panel.style.display === "block" ? "none" : "block";
    other1.style.display = "none";
    other2.style.display = "none";
  });
  document.getElementById("requestLink")?.addEventListener("click", (e) => {
    e.preventDefault();
    const panel = document.getElementById("requestPanel");
    const other1 = document.getElementById("notesPanel");
    const other2 = document.getElementById("changelogPanel");
    panel.style.display = panel.style.display === "block" ? "none" : "block";
    other1.style.display = "none";
    other2.style.display = "none";
  });
  document.addEventListener("click", (e) => {
    const notesPanel = document.getElementById("notesPanel");
    const changelogPanel = document.getElementById("changelogPanel");
    const requestPanel = document.getElementById("requestPanel");
    const notesLink = document.getElementById("notesLink");
    const changelogLink = document.getElementById("changelogLink");
    const requestLink = document.getElementById("requestLink");

    const clickedInsideNotes =
      (notesPanel && notesPanel.contains(e.target)) ||
      (notesLink && notesLink.contains(e.target));
    const clickedInsideChangelog =
      (changelogPanel && changelogPanel.contains(e.target)) ||
      (changelogLink && changelogLink.contains(e.target));
    const clickedInsideRequest =
      (requestPanel && requestPanel.contains(e.target)) ||
      (requestLink && requestLink.contains(e.target));

    if (!clickedInsideNotes) notesPanel.style.display = "none";
    if (!clickedInsideChangelog) changelogPanel.style.display = "none";
    if (!clickedInsideRequest) requestPanel.style.display = "none";
  });

  // 4) Collapsible sections
  document.querySelectorAll(".collapsible-toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      const content = btn.nextElementSibling;
      content.style.display =
        content.style.display === "block" ? "none" : "block";
    });
  });

  // ─── FAVORITE ALL ─────────────────────────────────────────────────────────
  const favoriteAllBtn = document.getElementById("favoriteAllBtn");
  favoriteAllBtn?.addEventListener("click", () => {
    // collect visible IDs from table & grid
    const tableIds = Array.from(
      document.querySelectorAll("#productsTableBody tr:not([style*='display: none'])")
    ).map((r) => r.dataset.productId);
    const gridIds = Array.from(
      document.querySelectorAll("#productGridContainer .product-card")
    )
      .filter((c) => c.style.display !== "none")
      .map((c) => c.dataset.productId);
    const visibleIds = Array.from(new Set([...tableIds, ...gridIds]));

    // update data
    favoritedProducts = Array.from(
      new Set([...favoritedProducts, ...visibleIds])
    );
    saveLocal("favoritedProducts", favoritedProducts);
    saveLocal("savedFavoritesList", favoritedProducts);

    // update table UI
    tableIds.forEach((pid) => {
      const row = document.querySelector(`tr[data-product-id="${pid}"]`);
      if (row) {
        row.classList.add("row-favorited");
        const btn = row.querySelector(".favorite-btn");
        btn && (btn.textContent = "♥", btn.classList.add("favorited"));
      }
    });

    // update grid UI
    gridIds.forEach((pid) => {
      const card = document.querySelector(
        `.product-card[data-product-id="${pid}"]`
      );
      if (card) {
        card.classList.add("favorited-card");
        const icon = card.querySelector(".overlay-fav-icon");
        icon && (icon.textContent = "♥", icon.classList.add("favorited"));
      }
    });

    // refresh buttons & dispatch
    updateFavoritesUIVisibility();
    document.dispatchEvent(new Event("favoritesUpdated"));
    if (isGridView) updateProductView();
  });

  // ─── CLEAR FAVORITES ───────────────────────────────────────────────────────
  const clearFavoritesBtn = document.getElementById("clearFavoritesBtn");
  clearFavoritesBtn?.addEventListener("click", () => {
    // collect visible IDs
    const tableIds = Array.from(
      document.querySelectorAll("#productsTableBody tr:not([style*='display: none'])")
    ).map((r) => r.dataset.productId);
    const gridIds = Array.from(
      document.querySelectorAll("#productGridContainer .product-card")
    )
      .filter((c) => c.style.display !== "none")
      .map((c) => c.dataset.productId);
    const visibleIds = Array.from(new Set([...tableIds, ...gridIds]));

    // remove from data
    favoritedProducts = favoritedProducts.filter(
      (id) => !visibleIds.includes(id)
    );
    saveLocal("favoritedProducts", favoritedProducts);
    saveLocal("savedFavoritesList", favoritedProducts);

    // update table UI
    tableIds.forEach((pid) => {
      const row = document.querySelector(`tr[data-product-id="${pid}"]`);
      if (row) {
        row.classList.remove("row-favorited");
        const btn = row.querySelector(".favorite-btn");
        btn && (btn.textContent = "♡", btn.classList.remove("favorited"));
      }
    });

    // update grid UI
    gridIds.forEach((pid) => {
      const card = document.querySelector(
        `.product-card[data-product-id="${pid}"]`
      );
      if (card) {
        card.classList.remove("favorited-card");
        const icon = card.querySelector(".overlay-fav-icon");
        icon && (icon.textContent = "♡", icon.classList.remove("favorited"));
      }
    });

    // reset saved-list UI if empty
    if (!favoritedProducts.length) {
      activeFavoriteName = null;
      renderSavedFavorites();
    }

    // refresh buttons & dispatch
    updateFavoritesUIVisibility();
    document.dispatchEvent(new Event("favoritesUpdated"));
    if (isGridView) updateProductView();
  });

    // ─── Save Favourites List ────────────────────────────
  const saveFavoritesBtn = document.getElementById("saveFavoritesListBtn");
  if (saveFavoritesBtn) {
    saveFavoritesBtn.addEventListener("click", () => {
      console.log("saveFavorites clicked"); // should now fire

      if (!favoritedProducts.length) {
        showToast("No favorites to save.", "error");
        return;
      }

      showInputModal("Enter a name for your favorite list:", (name) => {
        if (!name) return;

        const key = "savedFavoriteLists";
        const savedLists = loadLocal(key, {});
        if (savedLists[name]) {
          showToast("Name already exists.", "error");
          return;
        }

        // 1) actually save it
        savedLists[name] = favoritedProducts.slice();
        saveLocal(key, savedLists);

        // 2) make sure the Settings panel is open so we can render into it
        const panel = document.getElementById("columnTogglePanel");
        const isPanelOpen = panel && panel.style.transform === "translateX(0px)";
        if (!isPanelOpen) toggleColumnPanel();

        // 3) redraw the saved-favourites list
        renderSavedFavorites();

        // 4) let the user know
        showToast(`Saved "${name}"!`);
      });
    });
  }
}

window.openProductModalById = function (id, opts = {}) {
  const p = productMap?.[id] || allProducts?.find(x => x.id === id);
  if (p) openProductModal(p, opts);
};

window.bindUIEvents = bindUIEvents;
window.updateProductView = updateProductView;

// ── Login vs Account Dropdown ──
document.addEventListener("DOMContentLoaded", async () => {
  const wrap = document.getElementById("accountControls");
  if (!wrap) return;

  const isLoggedIn = !!(window.customer && window.customer.id);
  const defaultIcon = "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/account_circle.svg?v=1757430645";

  // helper: fetch display_name from profile API
  async function fetchProfileName(cid) {
    try {
      const res = await fetch(`https://gear-db-proxy.onrender.com/profiles/me?customerId=${cid}`);
      const data = await res.json();
      if (data?.ok && data.profile?.display_name) return data.profile.display_name;
    } catch (err) {
      console.warn("[accountControls] profile fetch failed", err);
    }
    return null;
  }

  if (!isLoggedIn) {
    wrap.innerHTML = `
      <button id="loginBtn" class="account-icon-btn" data-login-modal>
        <img src="${defaultIcon}" alt="Account" width="28" height="28" style="margin-right:6px;">
        <span class="account-label">Account</span>
      </button>
    `;
    return;
  }

  // Logged in → avatar + display name (or first_name)
  let avatarUrl = window.customer?.avatar_url;
  if (!avatarUrl && window.customer?.display_name && window.svgAvatarDataURI) {
    avatarUrl = window.svgAvatarDataURI(window.customer.display_name);
  }
  const iconSrc = avatarUrl || defaultIcon;

  // try display_name from customer, else fetch profile, else fallback to first_name
  let displayLabel = window.customer?.display_name || "";
  if (!displayLabel && window.customer?.id) {
    displayLabel = await fetchProfileName(window.customer.id) || "";
  }
  if (!displayLabel) {
    displayLabel = window.customer?.first_name || "";
  }

  wrap.innerHTML = `
    <div class="account-menu">
      <button id="accountBtn" class="account-icon-btn">
        <img src="${iconSrc}" alt="Account" width="28" height="28" style="border-radius:50%; margin-right:6px;">
        ${displayLabel ? `<span class="account-label">${displayLabel}</span>` : ""}
      </button>
      <div id="accountDropdown" class="account-dropdown" style="display:none;">
        <a href="/account?tab=activity" target="_blank">Activity</a>
        <a href="/account?tab=achievements" target="_blank">Achievements</a>
        <a href="/account?tab=rewards" target="_blank">Rewards</a>
        <a href="/account?tab=orders" target="_blank">Orders</a>
        <a href="/account?tab=settings" target="_blank">Settings</a>
        <a href="/account/logout">Log out</a>
      </div>
    </div>
  `;

  const btn = document.getElementById("accountBtn");
  const dropdown = document.getElementById("accountDropdown");

  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    dropdown.style.display =
      dropdown.style.display === "block" ? "none" : "flex";
  });

  document.addEventListener("click", () => {
    dropdown.style.display = "none";
  });
});

